import {
  SORT_BY_APPLICATION_NUMBER_IN_ASC_LOAN_KEY,
  SORT_BY_APPLICATION_NUMBER_IN_DESC_LOAN_KEY,
  SORT_BY_ASC_DATE,
  SORT_BY_DESC_DATE,
  SORT_BY_NAME_IN_ASC_LOAN_KEY,
  SORT_BY_NAME_IN_DESC_LOAN_KEY,
} from 'src/components/sorting';

const LOAN_APP_SORT_WITH_DATE_KEY = 'date';
const LOAN_APP_SORT_WITH_NAME_KEY = 'name';
export const LOAN_APP_SORT_WITH_APPLICATION_NUMBER_KEY = 'application_number';

/**
 * This will be for making the key string for sorting,to map the respective strings
 * to API configured keys ,so before changing this please confirm what keys is used in API
 */
export const queryParamsMapForAPI = {
  [SORT_BY_ASC_DATE]: LOAN_APP_SORT_WITH_DATE_KEY,
  [SORT_BY_DESC_DATE]: LOAN_APP_SORT_WITH_DATE_KEY,
  [SORT_BY_NAME_IN_ASC_LOAN_KEY]: LOAN_APP_SORT_WITH_NAME_KEY,
  [SORT_BY_NAME_IN_DESC_LOAN_KEY]: LOAN_APP_SORT_WITH_NAME_KEY,
  [SORT_BY_APPLICATION_NUMBER_IN_ASC_LOAN_KEY]: LOAN_APP_SORT_WITH_APPLICATION_NUMBER_KEY,
  [SORT_BY_APPLICATION_NUMBER_IN_DESC_LOAN_KEY]: LOAN_APP_SORT_WITH_APPLICATION_NUMBER_KEY,
};
